main();

async function main() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code') || urlParams.get('Code');
    const configuration = await fetchConfiguration(code);
    console.log(configuration);
    if (configuration?.Konfigurator == "Fronten") {
        exportCSV(configuration);
        window.close();
    } else {
        alert("No CSV-Export for this Configurator.")
    }
}

async function fetchConfiguration(code) {
    const backendURL = SETTINGS.wkfgBackendUrl;
    const response = await (await (fetch(`${backendURL}metamodell/config?Code=${code}&metamodel=false&metadata=false&settings=false`))).json();
    console.log(response);
    return response?.Konfiguration?.pop();
}

async function exportCSV(configuration) {
    const dataObject = configuration;
    const itemsFormatted = [];
    const headers = {
        position: "Pos",
        kommission: "Kommission",
        kundennummer: "Kundennummer",
        code: "Auftragsnummer/Code",
        beschreibung: "Plattennummer/Artikel",
        verlauf: "Strukturverlauf",
        dekor: "Dekor (Name)",
        dekorbeschreibung: "Dekorbeschreibung",
        hoehe: "Höhe",
        breite: "Breite",
        menge: "Menge",
        lieferadresse: "Lieferadresse",
        rechungsadresse: "Rechungsadresse",
        preiseinzel: "Preis einzeln",
        aufschlag: "Preisaufschlag",
        gesamtpreis: "Preis gesamt",
    };

    const createAdress = (haendler) => {
        return haendler.Strasse + " | " + haendler.PLZ + " " + haendler.Stadt;
    };

    const stammdaten = dataObject.Json.stammdaten;
    const formatter = new Intl.NumberFormat("de-de", {
        currency: "EUR",
    });
    // format the data
    dataObject.Json.positionen.forEach((item) => {
        itemsFormatted.push({
            pos: item.fronten_position, // remove commas to avoid errors,
            kommission: dataObject.Json.haendler.Name,
            kundennummer: dataObject.Json.haendler.Kundennummer,
            code: dataObject.Code,
            beschreibung: item.fronten_beschreibung,
            verlauf: item.fronten_verlauf,
            dekor: item.fronten_decor,
            dekorbeschreibung: item.fronten_dekorbeschreibung,
            hoehe: item.fronten_height,
            breite: item.fronten_width,
            menge: item.fronten_count,
            lieferadresse: dataObject.Json.haendler
                ? createAdress(dataObject.Json.haendler)
                : "",
            rechungsadresse: dataObject.Json.haendler
                ? createAdress(dataObject.Json.haendler)
                : "",
            preiseinzel: formatter.format(item.priceInfo?.qmPrice || 0),
            aufschlag: formatter.format(item.priceInfo?.fixedPrice || 0),
            gesamtpreis: formatter.format(item.fronten_sum),
        });
    });

    const fileTitle = dataObject.Code;
    exportCSVFile(headers, itemsFormatted, fileTitle);
}




function exportCSVFile(headers, items, fileTitle) {
    if (headers) {
        items.unshift(headers);
    }

    // Convert Object to JSON
    _.forEach(items, (object, index) => {
        _.forEach(object, (v, k) => {
            if (v === undefined) {
                object[k] = "";
            }
        });
    });
    var jsonObject = JSON.stringify(items);

    var csv = convertToCSV(jsonObject);

    var exportedFilenmae = fileTitle + ".csv" || "export.csv";

    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            // link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            // document.body.removeChild(link);
        }
    }
}

function convertToCSV(objArray) {
    var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    var str = "";

    for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
            if (line != "") line += ";";

            line += array[i][index];
        }

        str += line + "\r\n";
    }

    return str;
}

